module.exports = __webpack_public_path__ + "static/media/login-bg-datagas.3a6454d5.png";